export const appVersion = {
    namespaced: true,
    getters: {
        getAppVersion(){
            return BUNDLE_VERSION || APP_VERSION || '';
        }
    }
}
